import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const WorkbookQueryGql: DocumentNode = gql`
query WorkbookQuery($workbookVizportalUrlId: String!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}, permissionMode: FILTER_RESULTS) {
    name
    embeddedDatasources (orderBy: {field: NAME, direction: ASC}) {
      name
      id
      fieldsConnection(filter: { isHidden: false }) {
        totalCount
      }
    }
  }
}
`;
